<!--suppress ALL -->
<script lang="ts">
import {ukurans} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";
  import AppConfig from "../../../AppConfig";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class UkuranSelect extends Vue {

    @Prop({default: ukurans[0], type: String})
    private ukuran: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({default: false, type: Boolean})
    public disabled: boolean;

    @Prop({
      default: () => AppConfig.getVm().$t('label.ukuran').toString(),
      type: String
    })
    public label: string;

    @Prop({type: String, default: ""})
    public message: string;

    @Prop({type: String, default: ""})
    public type: string;

    public onSelectSekolah(param: string) {
      this.$emit('update:ukuran', param || ukurans[0].value);
      this.$emit('ukuran-selected', param);
    }

    public render(createElement: Function) {
      const {$t, ukuran, isFullwidth, label, message, type} = this;

      const mainAttr: any = {
        attrs: {disabled: this.disabled},
        props: {
          value: ukuran, isFullwidth,
          placeholder: `${$t('label.choose')} ${label}`
        },
        on: {change: this.onSelectSekolah}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(ukurans).map((item: any) => {
        const option: any = {attrs: {value: item.value}};

        return createElement('option', option, item.label);
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label, message, type}}, [main]);
    }
  }
</script>
